import { createPlugin } from '../../../../Fct/createPlugin';
import { FctAddress, FctAddressList, FctValue } from '../../../../Fct/generics';
import { ROUTER_V2_ADDRESSES } from '../constants';
export var GetAmountsOut = createPlugin({
    protocol: 'UNISWAP',
    type: 'GETTER',
    method: 'getAmountsOut',
    supportedContracts: ROUTER_V2_ADDRESSES,
    getParams: function () { return ({
        input: {
            to: new FctAddress({ destination: 'uniswap_router' }),
            methodParams: {
                amountIn: new FctValue({ destination: 'wei_amount' }),
                path: new FctAddressList({ destination: 'ERC20_List' }),
            },
        },
        output: {
            amountIn: new FctValue({ destination: 'wei_amount', innerIndex: 2 }),
            amountOut: new FctValue({ destination: 'wei_amount', innerIndex: -1 }),
        },
    }); },
});
